function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import colors from "styles/colors";
import classnames from "classnames";
import { encloseBoldTag } from "utils/strings";
import MondayMarkupLanguageComponent from "client/components/system/monday-markup-language/monday-markup-language-component";
import { StyledParagraph } from "./paragraph.scss";
import DefaultProps from "./default-props";
class Paragraph extends PureComponent {
    render() {
        const { body, textSize, isFirstSegment, className } = this.props;
        const CustomTag = isFirstSegment ? "h2" : "div";
        const style = this.getStyle();
        return /*#__PURE__*/ _jsx(StyledParagraph, {
            className: classnames("paragraph-wrapper", className),
            children: /*#__PURE__*/ _jsx(MondayMarkupLanguageComponent, {
                tagName: CustomTag,
                className: classnames("paragraph-body", textSize),
                text: encloseBoldTag(body),
                style: style
            })
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "getStyle", ()=>{
            const { bodyColor, textWidth } = this.props;
            let customStyle = {
                maxWidth: textWidth
            };
            if (bodyColor && colors[bodyColor]) {
                customStyle = _object_spread_props(_object_spread({}, customStyle), {
                    color: colors[bodyColor]
                });
            }
            return customStyle;
        });
    }
}
export { Paragraph as default };
Paragraph.defaultProps = DefaultProps;
